export const projects = [
  {
    id: 1,
    title: 'Future Now',
    subtitle: 'KI-Agentur-System mit Franchise- & Vertriebspartner-Modell',
    description: 'Future Now ist ein skalierbares KI-Agentur-System, das nicht auf individuelle Kundenprojekte, sondern auf wiederholbare Umsatzsysteme ausgelegt ist. Das Konzept eignet sich für Agenturen, Berater und Vertriebspartner, die KI-basierte Webseiten, Funnels und Automatisierungen anbieten möchten – ohne klassische Agenturprozesse.',
    icon: 'ri-rocket-2-fill',
    features: [
      'KI-gestützte Webseiten & Funnel-Vorlagen',
      'Automatisierte Lead-Erfassung & Vorqualifizierung',
      'KI-Chats & Follow-up-Automatisierungen',
      'Branchen-Templates (z. B. Makler, Berater, Dienstleister)',
      'Franchise- / White-Label-fähige Struktur',
      'Partner- & Provisionslogik',
      'Zentrale Steuerung & Skalierung ohne Support-Overhead'
    ],
    einsatzbereich: 'Franchise-Systeme, KI-Agenturen, Vertriebsorganisationen, digitale Geschäftsmodelle'
  },
  {
    id: 2,
    title: 'Health Leads',
    subtitle: 'Online Business Suite für Unternehmen im Gesundheitsbereich',
    description: 'Health Leads ist eine modulare Online-Business-Suite für Gesundheits-, Präventions- und Lifestyle-Unternehmen. Fokus liegt auf Lead-Generierung, Kundenbindung und automatisierter Beratung, kombiniert mit rechtssicherer Struktur.',
    icon: 'ri-heart-pulse-fill',
    features: [
      'Landingpages & Angebotsseiten für Gesundheitsprodukte',
      'Lead- & Interessenten-Management',
      'Automatisierte Informations- & Beratungsprozesse',
      'Vorqualifizierung von Kunden (z. B. Bedarf, Interesse, Status)',
      'Optional: Termin- & Follow-up-Automatisierung',
      'Skalierbar für Einzelunternehmer & Organisationen'
    ],
    einsatzbereich: 'Gesundheitsanbieter, Berater, Coaches, Produkt- & Empfehlungsmodelle'
  },
  {
    id: 3,
    title: 'SuperOne Partner',
    subtitle: 'Funnel- & Lead-System für Blockchain- & Vertriebsunternehmen',
    description: 'SuperOne Partner ist ein spezialisiertes Funnel- und Lead-System für Blockchain-basierte Vertriebsmodelle. Ziel ist es, Interessenten automatisiert zu informieren, zu qualifizieren und strukturiert in Partner- oder Kundenprozesse zu überführen.',
    icon: 'ri-links-fill',
    features: [
      'Vertriebs- & Partner-Funnels',
      'Automatisierte Informationsstrecken',
      'Lead-Scoring & Vorqualifizierung',
      'Dashboard-Logik für Partner',
      'Struktur für skalierbare Netzwerke',
      'Optional: Mehrsprachigkeit & Internationalisierung'
    ],
    einsatzbereich: 'Blockchain-Projekte, Affiliate- & Netzwerkmodelle, digitale Beteiligungsmodelle'
  },
  {
    id: 4,
    title: 'Mindshift AI',
    subtitle: 'KI-basiertes Motivations- & Mentaltraining-System',
    description: 'Mindshift AI ist eine KI-gestützte Plattform zur mentalen Ausrichtung, Motivation und Zielklarheit. Das System kombiniert Reflexion, Impulse und Struktur – ideal für Unternehmer, Performer und Persönlichkeitsentwicklung.',
    icon: 'ri-brain-fill',
    features: [
      'KI-gestützte Reflexions- & Fokus-Module',
      'Motivations- & Mindset-Impulse',
      'Ziel- & Fortschrittslogik',
      'Persönliche Routinen (täglich / wöchentlich)',
      'Erweiterbar für Coaching- & Kursmodelle'
    ],
    einsatzbereich: 'Persönlichkeitsentwicklung, Coaching, Unternehmer-Programme, Communities'
  },
  {
    id: 5,
    title: 'Learnsnap',
    subtitle: 'KI-basierte Nachhilfe- & Weiterbildungsplattform',
    description: 'Learnsnap ist eine flexible KI-Lernplattform für Nachhilfe, Weiterbildung und Wissensvermittlung. Sie kann für Schulen, Coaches, Unternehmen oder Bildungsprojekte eingesetzt werden – ohne Programmierkenntnisse.',
    icon: 'ri-graduation-cap-fill',
    features: [
      'KI-gestützte Lern- & Erklärlogik',
      'Strukturierte Wissens- & Lernpfade',
      'Individuelle Lernunterstützung',
      'Erweiterbar für Kurse, Trainings & Schulungen',
      'White-Label- & Mehrzweck-fähig'
    ],
    einsatzbereich: 'Nachhilfe, Weiterbildung, interne Schulungen, Wissensplattformen'
  },
  {
    id: 6,
    title: 'CryptoFit',
    subtitle: 'KI-basierte Krypto- & Trading-Akademie',
    description: 'CryptoFit ist eine fortgeschrittene KI-Trading- und Analyseplattform. Sie verbindet Wissensvermittlung, Live-Chart-Analysen, Trading-Auswertungen und Portfolio-Tracking in einem modularen System.',
    icon: 'ri-line-chart-fill',
    features: [
      'KI-gestützte Chart- & Marktanalysen',
      'Live-Trading-Analysen & Auswertungen',
      'Strukturierte Lern- & Analysebereiche',
      'Portfolio- & Performance-Tracking',
      'Credit-basiertes Abrechnungssystem',
      'Skalierbar von Einsteiger- bis Pro-Level'
    ],
    einsatzbereich: 'Krypto-Akademien, Trading-Communities, Analyse- & Education-Plattformen'
  }
];
